/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

/**
 * Services offered by a company
 */
export enum CompanyServiceEnum {
  /**
   * A repair workshop, can create repair estimates
   */
  WORKSHOP = "WORKSHOP",

  /**
   * The lawyer handling claims for compensation
   */
  LAWYER = "LAWYER",

  /**
   * The appraiser, can create appraisals based on report
   */
  APPRAISER = "APPRAISER",

  /**
   * Provides rental cars
   */
  RENTAL = "RENTAL",

  /**
   * Provides insurance services
   */
  INSURANCE = "INSURANCE",

  /**
   * Provides towing services
   */
  TOWING = "TOWING",

  /**
   * A leasing company owning the car or providing the leasing contract
   */
  LEASING = "LEASING",

  /**
   * "Schadenssteuerer", A damage broker, handling the damage management
   */
  DAMAGE_BROKER = "DAMAGE_BROKER",

  /**
   * "Versicherungsmakler", handling insurance information
   */
  INSURANCE_BROKER = "INSURANCE_BROKER"
}
